import { OperationRequestData } from "fs-pb-vue2/data/operationRequestData";
import { ServerCommandsControllerVue } from "fs-pb-vue2/vueModels/app/ServerCommandsControllerVue";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data/enums/declarationPropertiesTypes";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";
import { PreApprovedSolutionData } from "fs-pb-vue2/data/preApprovedSolutionData";

/**
 *  Класс для компоненты контроллера модального окна СБП заявок на перевод.
 */
export class ServerCommandsControllerVueGB extends ServerCommandsControllerVue {

  // Список предложений для пользователя
  public preApprovedSolutionData: PreApprovedSolutionData[] = [];

  /** Получение комманд с сервера */
  async getServerCommands(): Promise<OperationRequestData> {
    //if (!this.personStore.personInfo.Data.DefaultOutAccount || !this.contractsStore.contracts.Contracts?.length)
    if (!this.contractsStore.contracts.Contracts?.length)
      return null;
    let ord: OperationRequestData = new OperationRequestData();
    ord.respondentCode = this.respondentCode;
    ord.setProperty("take", '100', DeclarationPropertiesTypes.String);
    ord = await OperationsApi.executeOperationSendAsync(ord);
    return ord;
  }

  /** Подписка на получение комманд с сервера */
  async subscribeServerCommands() {
    try {
      const ord: OperationRequestData = await this.getServerCommands();
      
      if(ord && ord.listObjects) {
        const objectArray = Object.values(ord.listObjects);
      
        for (let i=0; i < objectArray.length; i++) {
          const object = objectArray[i];

          if (object.Properties) {
            const typeCommand = object.Properties.TypeCommand;
        
            if (typeCommand == "Me2MeAcceptDraft") {
              this.commandsModal = true;
              this.commandsProps = object.Properties;
            //} else if (typeCommand == "UpdateContracts") {
              // MessagingCenter.Send<Page>(MainPage, "OnRefresh");
              //response = ServerCommandData.OK;
            } else if (typeCommand == "PreApprovedSolution") {
              const preApprovedDataArray: PreApprovedSolutionData[] = [];

              objectArray.forEach((obj) => {
                if (obj.Properties && obj.Properties.TypeCommand == "PreApprovedSolution") {
                  const preApprovedData = new PreApprovedSolutionData(obj.Properties);
                  preApprovedDataArray.push(preApprovedData);
                }
              });
              this.configStore.setPreApprovedSolutionDataArray(preApprovedDataArray);
            }
          }
        }
      }
    } catch (error) {
        console.error('Error occurred in subscribeServerCommands:', error);
    } finally {
      setTimeout(() => {
        this.subscribeServerCommands();
      }, 10000);
    }
  }
}
